export const MANAGE_CREDIT_CARDS = {
    ADD_NEW_CARD_BUTTON: "add-new-card",
    US_STATE_SELECT: "US-STATE-SELECT",
    CANADA_STATE_SELECT: "CANADA-STATE-SELECT",
    CANCEL_BUTTON: "CANCEL_BUTTON",
    SAVE_BUTTON: "SAVE_BUTTON",
    NAME_ON_CARD_FIELD: "NAME_ON_CARD_FIELD",
    NICKNAME_FIELD: "NICKNAME_FIELD",
    CARD_NUMBER_FIELD: "card_number",
    EXPIRATION_FIELD: "EXPIRATION_FIELD",
    CVV_FIELD: "cvv",
    COUNTRY_SELECT: "COUNTRY-SELECT",
    ADDRESS_LINE1_FIELD: "ADDRESS_LINE1_FIELD",
    ADDRESS_LINE2_FIELD: "ADDRESS_LINE2_FIELD",
    CITY_FIELD: "CITY_FIELD",
    STATE_FIELD: "STATE_FIELD",
    ZIPCODE_FIELD: "ZIPCODE_FIELD",
    POSTCODE_FIELD: "POSTCODE_FIELD",
    REGION_SELECT: "REGION_SELECT",
    DELETE_BUTTON: "DELETE_BUTTON",
    DELETE_CONFIRM_BUTTON: "DELETE_CONFIRM_BUTTON",
    CARD_NAME_EXISTANT: "CARD_NAME_EXISTANT",
    EXPIRATION_EXISTANT: "EXPIRATION_EXISTANT",
    RECENTLY_UPDATED_BY_SPREEDLY: "RECENTLY_UPDATED_BY_SPREEDLY",
    STATE_SELECT: "STATE-SELECT",
    REGION_FIELD: "REGION_FIELD",
    CARD_SELECTION_DROPDOWN: "card-selection-dropdown",
    CC_SUCCESSFULLY_SAVED_OK: "cc_successfully_saved_ok",
    CHARGE_LEGAL_TEXT: "charge_legal_text",
    CHARGE_SUBMIT: "payment-modal-submit",
    ORDER_SEARCH_FIELD: "search-input",
    ORDER_RECORD_NUMBER: "order-record-",
    ORDER_PAYMENT_ICON: "icon-payment",
    AUTHORIZE_TERMS_BUTTON: "authorize-terms-button",
    NOT_AUTHORIZE_TERMS_BUTTON: "not-authorize-terms-button",
    AGREE_TERMS_BUTTON: "agree-terms-button",
    CONFIRM_BUYER_BUTTON: "confirm-buyer-button",
    CANCEL_BUYER_BUTTON: "cancel-buyer-button",
    SALES_REP_TERMS_CHECK: "sales-rep-terms-check",
    ADD_CC_TO_BUYER_CONTACTS: "add-cc-to-buyer-contacts",
    CONFIRM_BUYER_ADD_CARD_ON_BEHALF: "confirm-buyer-add-card-on-behalf",
    CARD_FIELDS_BACKGROUND: "card-fields-background",
    CARD_FORM_TITLE: "card-form-title",
    SECURITY_LOCK: "card-security-lock",
    SECURITY_MESSAGE: "card-security-message",
    CARD_ICON_VISA: "card-icon-visa",
    CARD_ICON_MASTER: "card-icon-master",
    CARD_ICON_DISCOVER: "card-icon-discover",
    CARD_ICON_AMEX: "card-icon-amex",
    CARD_ICON_DEFAULT: "card-icon-default",
    ADDRESS_FIELDS_BACKGROUND: "address-fields-background",
    TRANSACTION_SUCCESSFUL_BUTTON: "transaction-successful-button",
    CREDIT_CARD_CONTAINER: "credit-card-container",
    CREDIT_CARD_NICKNAME_FIELD: "credit-card-nickname-field",
    CREDIT_CARD_BRAND_SELECT: "credit-card-brand-select",
    CREDIT_CARD_LINKED_BRAND: "credit-card-linked-brand",
    DELETE_CANCEL_BUTTON: "delete-cancel-button",
};

export const MANAGE_PAYMENT_METHODS = {
    ADD_NEW_PAYMENT_METHOD_BUTTON: "add-new-payment-method-button",
    ADD_NEW_PAYMENT_METHOD_DROPDOWN: "add-new-payment-method-dropdown",
    ADD_NEW_CREDIT_CARD: "add-new-credit-card-menu-item",
    ADD_NEW_ACH_BANK_ACCOUNT: "add-new-ach-bank-account-menu-item",
    ADD_NEW_BANK_ACCOUNT_MODAL: "add-new-ach-bank-account-modal",
    CANCEL_BANK_ACCOUNT_BUTTON: "cancel-ach-bank-account-button",
    CANCEL_BANK_ACCOUNT_BUTTON_LOADING: "cancel-ach-bank-account-button-loading",
    SAVE_BANK_ACCOUNT_BUTTON: "save-ach-bank-account-button",
    SAVE_BANK_ACCOUNT_BUTTON_LOADING: "save-ach-bank-account-button-loading",
    PAYMENT_METHOD_NICKNAME_FIELD: "payment-method-nickname-field",
    ADD_NEW_ACH_BANK_ACCOUNT_MODAL: "add-new-ach-bank-account-modal",
    ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX: "accept-payment-method-terms-and-conditions-checkbox",
    ACCEPT_TERMS_AND_CONDITIONS_TEXT: "accept-payment-method-terms-and-conditions-text",
    CANCEL_ACH_BANK_ACCOUNT_BUTTON: "cancel-ach-bank-account-button",
    SAVE_ACH_BANK_ACCOUNT_BUTTON: "save-ach-bank-account-button",
    PAYMENT_METHOD_CONTAINER: "payment-method-container",
    PAYMENT_METHODS_FETCH_ERROR: "payment-methods-fetch-error",
    UPDATE_AUTHORIZED_BRANDS_ERROR: "update-authorized-brands-error",
    UPDATE_AUTHORIZED_BRANDS_SUCCESS: "update-authorized-brands-success",
    EDIT_PAYMENT_METHOD_NICKNAME_BUTTON: "edit-payment-method-nickname-button",
    EDIT_NICKNAME_INPUT: "edit-nickname-input",
    SAVE_NICKNAME_BUTTON: "save-nickname-button",
    REMOVE_BUTTON: "remove-button",
    REMOVE_DIALOG: "remove-dialog",
    CONFIRM_REMOVE_BUTTON: "confirm-remove-button",
    CANCEL_NICKNAME_EDIT_BUTTON: "cancel-edit-nickname-button",
    CANCEL_REMOVE_BUTTON: "cancel-remove-button",
    ADD_BRANDS_BUTTON: "add-brands-button",
    REMOVE_BRANDS_BUTTON: "remove-brands-button",
    AUTH_BRAND_CHIP: "auth-brand-chip",
    DROPDOWN_AUTH_BRAND_SEARCH: "dropdown-auth-brand-search",
    DROPDOWN_AUTH_BRAND_SELECT_ALL: "dropdown-auth-brand-select-all",
    DROPDOWN_AUTH_BRAND_CANCEL_BUTTON: "dropdown-auth-brand-cancel-button",
    DROPDOWN_AUTH_BRAND_SAVE_BUTTON: "dropdown-auth-brand-save-button",
    DROPDOWN_AUTH_BRAND_CHECKBOX: "dropdown-auth-brand-checkbox",
};
